// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leave-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.leave-table th,
.leave-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

.leave-table th {
  background: #f5f5f5;
}

.leave-table button {
  margin: 0 5px;
  padding: 5px 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/LeadDashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".leave-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\n.leave-table th,\r\n.leave-table td {\r\n  border: 1px solid #ddd;\r\n  padding: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.leave-table th {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.leave-table button {\r\n  margin: 0 5px;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
